module.exports = class Emitter {
  constructor() {
    this.$emitter = $({})
    this.on = proxyMethod('on')
    this.one = proxyMethod('one')
    this.off = proxyMethod('off')
  }

  trigger(ev, ...vals) {
    this.$emitter.trigger(ev, vals)
    return this
  }
}

function proxyMethod(methodName) {
  return function () {
    this.$emitter[methodName].apply(this.$emitter, arguments)
    return this
  }
}
